<template>
  <div v-if="timespan" class="count-down">
    <span>距服务到期仅剩</span>
    <span class="time"><i>{{ timespan.day }}</i
      >天<i>{{ timespan.hour }}</i
      >时<i>{{ timespan.minute }}</i
      >分<i>{{ timespan.second }}</i
      >秒</span
    >
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    time: Date,
  },
  data() {
    return {
      timespan: null,
      timer: null,
    };
  },
  watch: {
    time: {
      immediate: true,
      handler(newValue){
        if (newValue) {
          this.clearTimer();

          let total = (newValue.getTime() - new Date().getTime()) / 1000; //时间差的总秒数;
          this.countdown(total);

          this.timer = setInterval(() => {
            total--;
            this.countdown(total);
          }, 1000);
        } else {
          this.timespan = null;
        }
      }
    }
  },
  methods: {
    countdown(total) {
      if (total <= 0) {
        this.timespan = { day: "00", hour: "00", minute: "00", second: "00" };
        this.clearTimer();
        return;
      }

      let ts = this.getTimeSpan(total);

      let day = ts.day > 9 ? ts.day : "0" + ts.day;
      let hour = ts.hour > 9 ? ts.hour : "0" + ts.hour;
      let minute = ts.minute > 9 ? ts.minute : "0" + ts.minute;
      let second = ts.second > 9 ? ts.second : "0" + ts.second;
      this.timespan = { day, hour, minute, second };
    },
    getTimeSpan(total) {
      let day = parseInt(total / (24 * 3600));
      let hour = parseInt((total / 3600) % 24);
      let minute = parseInt((total / 60) % 60);
      let second = parseInt(total % 60);
      return { day, hour, minute, second };
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
  beforeDestroy () {
    this.clearTimer();
  },
};
</script>

<style lang="less" scoped>
  .count-down{
    display: flex;
    flex-direction: column;
    font-size: 11px;
    .time{
      margin-top: 5px;
      i {
        width: 25px;
        height: 20px;
        line-height: 20px;
        font-style: normal;
        display: inline-block;
        text-align: center;
        background: #e2e2e2;
        border-radius: 2px;
        color: #000;
        font-size: 14px;
        &:first-child{
          margin-right: 2px;
        }
        &:not(:first-child){
          margin: 0 2px;
        }
      }
    }
  }
</style>